import type { AuditEntry, Paged } from '@order-pilot/shared';
import { api, queryString } from '@/lib/api';

/** Filters as the page holds them: '' means "no filter", which never hits the wire. */
export interface AuditFilters {
  tenantId: string;
  actorKind: string;
  action: string;
  from: string;
  to: string;
}

export const EMPTY_AUDIT_FILTERS: AuditFilters = {
  tenantId: '',
  actorKind: '',
  action: '',
  from: '',
  to: '',
};

export interface AuditListParams extends AuditFilters {
  page: number;
  pageSize: number;
}

export const auditKeys = {
  all: ['audit'] as const,
  list: (params: AuditListParams) => ['audit', 'list', params] as const,
  actions: () => ['audit', 'actions'] as const,
};

export function fetchAuditEntries(
  params: AuditListParams,
  signal?: AbortSignal,
): Promise<Paged<AuditEntry>> {
  // `queryString` drops empty values, and the API rejects unknown params
  // (forbidNonWhitelisted), so only the filters actually set are ever sent.
  const search = queryString({
    page: params.page,
    pageSize: params.pageSize,
    tenantId: params.tenantId,
    actorKind: params.actorKind,
    action: params.action,
    from: params.from,
    to: params.to,
  });
  return api.get<Paged<AuditEntry>>(`/admin/audit${search}`, { signal });
}

/** The action values that actually occur, for the filter dropdown. */
export function fetchAuditActions(signal?: AbortSignal): Promise<string[]> {
  return api.get<string[]>('/admin/audit/actions', { signal });
}
